(function () {
  const COOKIE_NAME = '_pandectes_gdpr';
  const TARGET_SELECTOR = '.cc-revoke';

  function getConsentStatus() {
    const cookie = document.cookie
      .split("; ")
      .find(c => c.startsWith(COOKIE_NAME + "="));

    if (!cookie) {
      return null;
    }

    const raw = cookie.split("=")[1];

    let decoded = raw;

    // Detect base64: starts with ey... and contains no { or "
    const looksBase64 =
      /^[A-Za-z0-9+/=]+$/.test(raw) &&
      !raw.includes("{") &&
      !raw.includes('"');

    if (looksBase64) {
      try {
        decoded = atob(raw);
      } catch (e) {
        return null;
      }
    }

    try {
      const data = JSON.parse(decoded);
      return data.status || null;
    } catch (e) {
      return null;
    }
  }

  function hideIfAccepted() {
    const status = getConsentStatus();

    if (status !== "allow") return;

    const el = document.querySelector(TARGET_SELECTOR);
    if (el) {
      el.style.display = "none";
      el.style.visibility = "hidden";
      el.style.opacity = "0";
      el.setAttribute("aria-hidden", "true");
    }
  }

  function init() {
    hideIfAccepted();

    const observer = new MutationObserver(() => hideIfAccepted());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
